import { ic } from '@/components/Icons';
import { EmptyState } from '@/components/ui';
import { userOrgIds } from '@/data';
import { useI18n } from '@/i18n';
import { useRoute } from '@/hooks/useRoute';
import { useAppStore } from '@/store/useAppStore';
import { OrgList } from './OrgList';
import { OrgDetail } from './OrgDetail';

/**
 * ETC Admin with no org selected → the full list.
 * A partner manager tied to several organizations → a picker first.
 * Otherwise → straight to the detail of the org in scope.
 */
export function OrgScreen() {
  const { lang } = useI18n();
  const route = useRoute();
  const role = useAppStore((s) => s.role);
  const user = useAppStore((s) => s.user);

  if (role === 'ETC_ADMIN' && !route.orgId) return <OrgList />;

  const oids = userOrgIds(user);
  if (role === 'PARTNER_MGR' && oids.length > 1 && !route.orgId) {
    return (
      <OrgList
        orgIds={oids}
        title={lang === 'es' ? 'Mis organizaciones' : 'My organizations'}
        sub={lang === 'es' ? `${oids.length} organizaciones en tu alcance` : `${oids.length} organizations in your scope`}
      />
    );
  }

  const orgId = route.orgId || oids[0] || user?.orgId;
  if (!orgId) {
    return <EmptyState icon={ic.org} title={lang === 'es' ? 'Sin organización en tu alcance' : 'No organization in scope'} />;
  }
  return <OrgDetail orgId={orgId} />;
}
